import { Component } from '@angular/core';

@Component({
  selector: 'lib-survey-loading',
  imports: [],
  templateUrl: './survey-loading.html',
  styleUrl: './survey-loading.css',
})
export class SurveyLoading {

}
